<template>
  <svg class="p-icon" :style="{ fill: color , width: size + 'em' , height: size + 'em'}">
    <use :xlink:href="`#i-${name}`" />
  </svg>
</template>
<script>
import "./svg";
export default {
  name: "PineIcon",
  props: {
    name: {
      type: String
    },
    color: {
      type: String
    },
    size: {
      type: Number,
      default: 1
    }
  }
};
</script>
<style scoped>
.p-icon {
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/common/icon.vue